/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChosenDescription = {
    Inferred: 'INFERRED',
    Original: 'ORIGINAL'
} as const;
export type ChosenDescription = typeof ChosenDescription[keyof typeof ChosenDescription];


export function instanceOfChosenDescription(value: any): boolean {
    for (const key in ChosenDescription) {
        if (Object.prototype.hasOwnProperty.call(ChosenDescription, key)) {
            // @ts-ignore
            if (ChosenDescription[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChosenDescriptionFromJSON(json: any): ChosenDescription {
    return ChosenDescriptionFromJSONTyped(json, false);
}

export function ChosenDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChosenDescription {
    return json as ChosenDescription;
}

export function ChosenDescriptionToJSON(value?: ChosenDescription | null): any {
    return value as any;
}

